module.exports = __webpack_public_path__ + "static/img/lj_pic3.ecf2f84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/nav/lj_pic3.jpg
// module id = pj3R
// module chunks = 37